const baseBackendUrl = process?.env?.VUE_APP_BACKEND_AUTH_URL;

export default {
  AUTH_URL: baseBackendUrl,
  REGISTER: `${baseBackendUrl}/register`,
  LOGIN: `${baseBackendUrl}/login`,
  LOGOUT: `${baseBackendUrl}/logout`,
  VERIFICATION: `${baseBackendUrl}/verification`,
  USERS: `${baseBackendUrl}/users`,
  OTP: `${baseBackendUrl}/otp`,
  BANNERS: `${baseBackendUrl}/banners`,
  OAUTH2: `${baseBackendUrl}/oauth2/google`,
  // https://id-staging.bizflycloud.vn/api/v1/dashboard/oauth2/callbacks/openid
  OPENID: `${baseBackendUrl}/oauth2/callbacks/openid`,
};
